import React from 'react'
import cloud_icon from '../../../assets/img/icons-cloud.png'
import { useSelector } from 'react-redux'

const Save = (props) => {
  const { save_btn_text } = useSelector(state => state.uiReducer)
    return (
      <div>
        <div className='save' onClick={() => props.savePen()}>
        <div className='line'></div>
          <img className='saveIcon' src={cloud_icon} alt="" />
          <p className='fork'>{ save_btn_text }</p>
        </div>
      </div>
    )
  }


export default Save


// WEBPACK FOOTER //
// ./src/components/NavBar/components/Save.js